import React from 'react';
import styles from '../../../styles/ListingManagement.module.css';
import type { ListingFilters } from '../../../types/ListingTypes';

interface FilterProps {
    filters: any;
    handleFilterChange(key: keyof ListingFilters, value: string): void;
}

const ListFilterBar: React.FC<FilterProps> = ({ filters, handleFilterChange }) => {
    return (
      <div className={styles.listingFilterBarNew}>
        <select
          className={styles.filterSelect}
          value={filters.type ?? ''}
          onChange={(e) => handleFilterChange('type', e.target.value)}
        >
          <option value="">All Types</option>
          <option value="Sale">Sale</option>
          <option value="Rental">Rental</option>
        </select>
        <select
          className={styles.filterSelect}
          value={filters.status ?? ''}
          onChange={(e) => handleFilterChange('status', e.target.value)}
        >
          <option value="">All Statuses</option>
          <option value="Open">Open</option>
          <option value="Pending">Pending</option>
          <option value="Closed">Closed</option>
          <option value="Incomplete">Incomplete</option>
        </select>
        <div className={styles.filterDivider} />
        <input
          className={styles.filterInput}
          type="text"
          placeholder="Filter by city…"
          value={filters.city ?? ''}
          onChange={(e) => handleFilterChange('city', e.target.value)}
        />
        <input
          className={styles.filterInput}
          type="text"
          placeholder="Filter by address…"
          value={filters.address ?? ''}
          onChange={(e) => handleFilterChange('address', e.target.value)}
        />
      </div>
    );
}

export default ListFilterBar;